import { MenuItem } from "./../menu/menu-item";
import { Component, OnDestroy, OnInit, Input } from "@angular/core";
import { Usuario } from "../../../modules/seguranca/usuario/usuario";
import { LayoutCss } from "../../../modules/basico/layout-css/layout-css";
import { UnidadeGestora } from "../../../modules/basico/unidade-gestora/unidade-gestora";
import { SharedService } from "../../../common/shared.service";
import { Router } from "@angular/router";
import { UsuarioService } from "../../../modules/seguranca/usuario/usuario.service";
import {
  NotificacaoListItem,
  NotificacaoService,
} from "../../../modules/notificacao/notificacao.service";
import { Subscription, interval } from "rxjs";

@Component({
  selector: "app-menu-modulo",
  templateUrl: "./menu-modulo.component.html",
  styleUrls: ["./menu-modulo.component.css"],
})
export class MenuModuloComponent implements OnInit, OnDestroy {
  @Input() modulo;
  @Input() menu: MenuItem[] = [];
  bgNav: string = "bg-danger";
  navBarText: string = "navbar-dark";
  bgSub: string = "bg-danger";
  bgSub2: string = "bg-danger";
  usuario: Usuario;
  layout: LayoutCss;
  unidade: UnidadeGestora;
  notificacoes: NotificacaoListItem[] = [];
  unreadCount = 0;
  notificacoesLoading = false;

  private pollSub: Subscription;

  constructor(
    private shared: SharedService,
    private router: Router,
    private usuarioService: UsuarioService,
    private notificacaoService: NotificacaoService
  ) {}

  ngOnInit() {
    this.usuario = this.shared.usuario;
    this.layout = this.shared.layout;
    this.unidade = this.shared.unidade;
    this.navBarText = this.layout.secondaryColor.colorNav;
    this.bgNav = this.layout.secondaryColor.colorBg;
    this.bgSub = this.layout.secondaryColor.colorBg;
    this.bgSub2 = this.layout.secondaryColor.colorBg;
    this.carregarNotificacoes();
    this.pollSub = interval(60000).subscribe(() => this.carregarNotificacoes());
  }

  ngOnDestroy() {
    if (this.pollSub) {
      this.pollSub.unsubscribe();
    }
  }

  carregarNotificacoes() {
    this.notificacaoService.contagemNaoLidas().subscribe({
      next: (res) => {
        this.unreadCount = res.count || 0;
      },
    });

    this.notificacoesLoading = true;
    this.notificacaoService.listar(0, 5).subscribe({
      next: (res) => {
        this.notificacoes = res.rows || [];
        this.notificacoesLoading = false;
      },
      error: () => {
        this.notificacoesLoading = false;
      },
    });
  }

  marcarLida(event: Event, item: NotificacaoListItem) {
    event.preventDefault();
    event.stopPropagation();
    if (item.lida) {
      return;
    }
    this.notificacaoService.marcarLida(item.publicId).subscribe({
      next: () => {
        item.lida = true;
        if (this.unreadCount > 0) {
          this.unreadCount -= 1;
        }
      },
    });
  }

  marcarTodasLidas(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.unreadCount === 0) {
      return;
    }
    this.notificacaoService.marcarTodasLidas().subscribe({
      next: () => {
        this.notificacoes.forEach((item) => {
          item.lida = true;
        });
        this.unreadCount = 0;
      },
    });
  }

  verTodas(event: Event) {
    event.preventDefault();
    this.router.navigate(["/notificacoes"]);
  }

  logout() {
    this.usuarioService.logout().subscribe();
    this.shared.logout();
    this.router.navigate(["/login"]);
  }
}
